import React, { useState } from 'react';

function MobileDoctorNotifications({ user, onBack }) {
  const [notifications, setNotifications] = useState([
    { id: 1, type: 'request', icon: 'person_add', color: 'bg-blue-50 text-blue-600', title: 'Access Approved', desc: 'Abhivardhan Nayak approved your access request', time: '2 mins ago', read: false },
    { id: 2, type: 'report', icon: 'upload_file', color: 'bg-purple-50 text-purple-600', title: 'New Report Uploaded', desc: 'Kavita Reddy uploaded a new Blood Test report', time: '1 hour ago', read: false },
    { id: 3, type: 'request', icon: 'notifications', color: 'bg-amber-50 text-amber-600', title: 'Access Request Pending', desc: 'Your request to Meera Kapoor is pending approval', time: '3 hours ago', read: true },
    { id: 4, type: 'report', icon: 'auto_awesome', color: 'bg-green-50 text-green-600', title: 'AI Summary Ready', desc: 'Health summary for Sunita Sharma has been generated', time: 'Yesterday', read: true },
  ]);

  const markAllRead = () => setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    // REMOVED 'pt-16' TO FIX THE UNWANTED GAP
    <div className="pb-6 bg-[#f9f9fc] min-h-full" style={{ fontFamily: 'Inter, sans-serif' }}>
      
      {/* SUB-SCREEN HEADER */}
      <div className="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-100 sticky top-0 z-10">
        <div className="flex items-center gap-3">
          <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 active:scale-95 transition-all">
            <span className="material-symbols-outlined text-gray-500">arrow_back</span>
          </button>
          <span className="font-black text-[#0d1b2a] text-base">Notifications</span>
          {unreadCount > 0 && (
            <span className="w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
              {unreadCount}
            </span>
          )}
        </div>
        {unreadCount > 0 && (
          <button onClick={markAllRead} className="text-xs font-bold text-[#0B3C95] hover:underline">Mark all read</button>
        )}
      </div>

      <div className="px-4 pt-4 pb-4 space-y-2">
        {notifications.map(n => (
          <div key={n.id} onClick={() => setNotifications(prev => prev.map(x => x.id === n.id ? { ...x, read: true } : x))}
            className={`bg-white rounded-2xl p-4 flex items-start gap-3 border active:scale-[0.99] transition-all cursor-pointer ${n.read ? 'border-gray-100' : 'border-[#0B3C95]/20'}`}
            style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${n.color}`}>
              <span className="material-symbols-outlined text-xl" style={{ fontVariationSettings: '"FILL" 1' }}>{n.icon}</span>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <p className={`text-sm font-bold ${n.read ? 'text-gray-600' : 'text-[#0d1b2a]'}`}>{n.title}</p>
                {!n.read && <div className="w-2 h-2 bg-[#0B3C95] rounded-full shrink-0 mt-1.5"></div>}
              </div>
              <p className="text-xs text-gray-400 mt-0.5 leading-relaxed">{n.desc}</p>
              <p className="text-[10px] text-gray-300 mt-1">{n.time}</p>
            </div>
          </div>
        ))}

        {notifications.length === 0 && (
          <div className="bg-white rounded-2xl p-8 text-center border border-gray-100">
            <span className="material-symbols-outlined text-gray-200 text-5xl block mb-3">notifications_off</span>
            <p className="text-gray-400 font-semibold">No notifications yet</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MobileDoctorNotifications;